import { useMemo, useState } from "react";
import { useLocation, Navigate } from "react-router-dom";
import ProductsList from "../../components/LicenseManagement/ProductsList";
import {
  GetClassesBySchoolId,
  GetUserByEmail,
} from "../../actions/adminQueries";
import { buildAdminOrderContext } from "../../Utilities/licenseHelper";
import { attachClassToStudent } from "../../Utilities/studentHelper";

// Admins väg till lärarens katalogsida: samma ProductsList, men med skola, elever och
// beställare inskickade utifrån i stället för uppslagna via inloggad användares mejl.
// Utan preselectedStudents är klassläget av, så korten och "Enbart pluspaket" visas —
// det är den enda vägen där admin kan köpa APL till många elever på ett bräde.
function AdminShop() {
  const location = useLocation();

  // ProductsList läser skolan direkt ur localStorage, så den måste vara skriven innan
  // första renderingen — därav skrivningen i initialiseraren och inte i en effekt.
  const [school] = useState(() => {
    const fromState = location.state?.school;
    if (fromState) {
      localStorage.setItem("school", JSON.stringify(fromState));
    }
    return fromState ?? JSON.parse(localStorage.getItem("school"));
  });

  const classesQuery = GetClassesBySchoolId(school?.id);
  const currentUserQuery = GetUserByEmail(localStorage.getItem("email"));

  const studentsWithClass = useMemo(
    () =>
      (classesQuery.data || []).flatMap((c) =>
        (c.students || []).map((s) => attachClassToStudent(s, c)),
      ),
    [classesQuery.data],
  );

  const orderContext = useMemo(
    () =>
      buildAdminOrderContext(
        school,
        currentUserQuery.data,
        // Ingen klass i det här läget, alltså ingen fortnox-referens att förifylla.
        null,
        "/superuser/schools",
      ),
    [school, currentUserQuery.data],
  );

  if (!school) {
    return <Navigate to="/superuser/schools" replace />;
  }

  return (
    <div>
      <div className="card card-body">
        <h5 className="no-margin">Shop {school.name}</h5>
      </div>
      <ProductsList orderContext={orderContext} students={studentsWithClass} />
    </div>
  );
}

export default AdminShop;
